module.exports = __webpack_public_path__ + "static/media/en.96afdddc.svg";